module.exports = __webpack_public_path__ + "static/facebook-996c7213995ff18ab6048e7975f53adb.jpg";